import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ExternalVideoManagerComponent } from './external-video-manager.component';
import { TooltipInputModule } from '../tooltip-input/tooltip-input.module';
import { MotePipesModule } from '../../pipes';
import { SimpleModalModule } from '../simple-modal/simple-modal.module';

@NgModule({
    declarations: [ExternalVideoManagerComponent],
    imports: [
        CommonModule,
        TooltipInputModule,
        FormsModule,
        MotePipesModule,
        SimpleModalModule
    ],
    exports: [ExternalVideoManagerComponent]
})
export class ExternalVideoManagerModule { }
